import {AbstractEvent} from "@/modules/base/events";
import {YouthPlayer} from "../entity";

export class BeforeYouthPlayerRecruitmentEvent extends AbstractEvent {
  constructor(
    public player: YouthPlayer,
  ) {
    super();
  }
}